import { connect } from 'react-redux';

import { destroy } from '../../modules/actions/session';
import { isAdmin, isSubcontractor } from '../../modules/selectors/permissions';
import { openLeftBar, closeLeftBar, openLeftBarModule, closeLeftBarModule } from '../../modules/actions/layout';
import {
  isLeftBarOpen,
  selectLeftBar,
  isLeftBarModuleOpen,
  selectLeftBarModule,
  getLeftBarModuleExtra
} from '../../modules/selectors/layout';
import LeftBar from './LeftBar';

const mapStateToProps = (state) => ({
  open: isLeftBarOpen(state),
  moduleOpen: isLeftBarModuleOpen(state),
  bar: selectLeftBar(state),
  module: selectLeftBarModule(state),
  extra: getLeftBarModuleExtra(state),
  isAdmin: isAdmin(state),
  isSubcontractor: isSubcontractor(state),
});

const mapDispatchToProps = {
  destroy,
  openLeftBar,
  closeLeftBar,
  openLeftBarModule,
  closeLeftBarModule,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeftBar);
